import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { ButtonIw } from '@/_pages/interwill/components/ButtonIw';
import { media } from '@/shared/components';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { ExitOnboardingModalProps } from '@/widgets/modals/types';

import { ModalContainerV2 } from '../containers/ModalContainerV2';

export const ExitOnboardingModal: FC<ExitOnboardingModalProps> = ({ savedStep }) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'exitOnboarding' });

  const modals = useModalsStore();

  return (
    <ModalContainerV2 pinBottom title={t('title')}>
      <Content>
        <div>{t('text1')}</div>
        <div>{t('text2')}</div>
      </Content>
      <Buttons>
        <ButtonIw
          type="default"
          onClick={() => {
            modals.closeModal();
            modals.openModal({
              type: 'WelcomeModal',
              step: savedStep - 1,
            });
          }}
        >
          {t('cancelBtn')}
        </ButtonIw>
        <ButtonIw onClick={modals.closeModal}>{t('exitBtn')}</ButtonIw>
      </Buttons>
    </ModalContainerV2>
  );
};

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  gap: 16px;

  ${media.iwMobile} {
    flex-direction: column-reverse;
  }
`;

const Content = styled.div`
  padding: 24px 0;
  font-size: 14px;

  ${media.iwMobile} {
    padding: 16px 0;
  }
`;
